import {
  Timeline,
  TimelineItem,
  timelineItemClasses,
  timelineOppositeContentClasses,
} from '@mui/lab';
import { useEffect, useState } from 'react';
import { ActivityLogSearchResponse, ActivityLog } from 'wisestep-api';
import { WsTypography, WsTypoColors, WsTypoVariants, timeCalendarSince } from 'wisestep-base';

import JobActivityItem from '../../../../../jobsCrm/activityLogJob/JobActivityItem';

import ActivityLogItem from './components/ActivityLogItem';

interface TimeLineProps {
  onclick: (activity: ActivityLog) => void;
  activity?: ActivityLogSearchResponse;
  openPreview?: (action: boolean) => void;
  logId?: (id: string) => void;
  closeDialog?: boolean;
  jobsActivity?: boolean;
}

const TimeLine = ({
  onclick,
  activity = {},
  openPreview,
  logId,
  closeDialog = false,
  jobsActivity = false,
}: TimeLineProps) => {
  const [selectedRow, setSelectedRow] = useState<string>('');
  const [dialogClosed, setDialogClosed] = useState<boolean>(closeDialog);

  const onclickView = (id: string) => {
    setSelectedRow(id);
    if (selectedRow === id) {
      setSelectedRow('');
    }
  };
  useEffect(() => {
    if (closeDialog) {
      setSelectedRow('');
      setDialogClosed(!dialogClosed);
    }
  }, [closeDialog]);

  return (
    <Timeline
      position="right"
      {...{
        sx: {
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
          [`& .${timelineOppositeContentClasses.root}`]: {
            flex: 0.2,
          },
        },
      }}
    >
      <TimelineItem sx={{ ml: 20, minHeight: 40 }}>
        <WsTypography color={WsTypoColors.BLACK} variant={WsTypoVariants.TITLE} bold>
          {timeCalendarSince(activity.date)}
        </WsTypography>
      </TimelineItem>

      {activity?.activities?.map((activity, index, row) =>
        jobsActivity ? (
          <JobActivityItem
            key={activity.id}
            index={index}
            activity={activity}
            isLast={index + 1 === row.length}
            // rowId={row}
            // selectedButtonId={selectedRow}
            // onClickView={() => onclickView(activity.id ?? '')}
            // openPreview={openPreview}
            // logId={logId}
          />
        ) : (
          <ActivityLogItem
            key={`${activity.id}-${activity.jobId}`}
            index={index}
            candidate={''}
            isLast={index + 1 === row.length}
            onclick={onclick}
            activity={activity}
            openPreview={openPreview}
            auditId={activity.auditLogId ?? ''}
            logId={logId}
            rowId={row}
            selectedButtonId={selectedRow}
            onClickView={() => onclickView(row[index].id ?? '')}
          />
        )
      )}
    </Timeline>
  );
};
export default TimeLine;
